import axios from 'axios'

const email = process.env.VUE_APP_EGPRO_EMAIL
const password = process.env.VUE_APP_EGPRO_PASSWORD
const api_key = process.env.VUE_APP_API_KEY


// En CLI usamos process.env para las variables del .env
const apiBaseUrl = process.env.VUE_APP_API 

export const api = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

// Agregamos el api key para la peticion de ListCoursesSummary
api.interceptors.request.use(config => {
  // 1. Siempre incluimos la API Key si existe (peticiones públicas/summary)
  if (api_key) {
    config.headers['x-api-key'] = api_key
  }

  // 2. Si el usuario está logueado, agregamos el JWT (peticiones privadas/inscripciones)
  // Generalmente guardas el token en localStorage tras el login
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }

  return config
}, error => {
  return Promise.reject(error)
})

/**
 * Obtiene el resumen de cursos para la landing page (Live Training Summary)
 * Esta petición usará la x-api-key automáticamente.
 */
export const getLiveTrainingSummary = async () => {
  try {
    const response = await api.get('/courses/live-training-summary/');
    return response.data;
  } catch (error) {
    console.error("Error fetching tactical summary:", error);
    throw error;
  }
}

/**
 * Obtiene el listado de cursos para la sección de Cursos (List Courses)
 * Esta petición también usará la x-api-key automáticamente.
 */
export const getLiveTrainingList = async () => {
  try {
    const response = await api.get('/courses/live-training-list/');
    return response.data;
  } catch (error) {
    console.error("Error fetching tactical list:", error);
    throw error;
  }
}

/**
 * Obtenemos el detalle de un curso específico por su ID (Course Detail)
 * Esta petición también usará la x-api-key automáticamente.
 */
export const getCourseDetail = async (courseId) => {
  try {
    const response = await api.get(`/courses/${courseId}/`); 
    return response.data;
  } catch (error) {
    console.error(`Error fetching course detail for ID ${courseId}:`, error);
    throw error;
  }
}

/**
 * Realiza la inscripción a un curso específico (recive un payload)
 * Esta petición requiere autenticación, por lo que se incluirá el JWT automáticamente.
 * El backend validará el JWT y procesará la inscripción.
  */
export const postInscripcion = async (payload) => {
  try {
    const response = await api.post('/courses/inscription/', payload);
    return response.data;
  } catch (error) {
    console.error("Error during course inscription:", error);
    throw error;
  }
}